import { Embed } from "./components";
import { EmbedPageContent } from "./components/EmbedPageContent";
import { Modal as EmbedModal, ModalProps as EmbedModalProps } from "./components/Modal";
import { MetabaseGuestEmbedPreview } from "./components/services/MetabaseGuestEmbedPreview";
import { buildEmbedProps, type EmbeddableRow } from "./functions";
import type {
  AirtableProps as AirtableEmbedProps,
  HubspotFormProps as HubspotFormEmbedProps,
  MetabaseDashboardProps as MetabaseDashboardEmbedProps,
  MetabaseGuestEmbedProps as MetabaseGuestEmbedEmbedProps,
  Props as EmbedProps,
  ScribeProps as ScribeEmbedProps,
  YouTubeProps as YouTubeEmbedProps,
} from "./types";
import { propsSchema as embedPropsSchema } from "./types";

export { Embed, EmbedModal, EmbedPageContent, MetabaseGuestEmbedPreview, buildEmbedProps, embedPropsSchema };
export type {
  EmbedModalProps,
  EmbedProps,
  EmbeddableRow,
  AirtableEmbedProps,
  HubspotFormEmbedProps,
  MetabaseDashboardEmbedProps,
  MetabaseGuestEmbedEmbedProps,
  ScribeEmbedProps,
  YouTubeEmbedProps,
};
